import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export const useOrdersRootOverflow = () => {
    const {pathname} = useLocation();

    useEffect(() => {
        const root = document.getElementById('root');
        if (!root) return;

        const isOrders = pathname === '/orders' || pathname.startsWith('/orders/');

        if (isOrders) {
            root.classList.add('orders-scroll');
        } else {
            root.classList.remove('orders-scroll');
        }

        return () => {
            root.classList.remove('orders-scroll');
        };
    }, [pathname]);
};
